import { type Package } from '@qdrant/qdrant-cloud-public-api/booking/v1';
import { millicentsToMonthlyPrice } from '@/components/Billing/helpers';
import { FRACTIONAL_TO_BASIC_MONETARY_UNIT_FACTOR } from './constants';
import { type PricedEntityRates } from './types';

export function getPricedEntityRates({
  entity,
  multiplier = 1,
}: {
  entity?: Package;
  multiplier?: number;
}): PricedEntityRates {
  const hourlyRatePerUnit = entity?.unitIntPricePerHour;
  if (typeof hourlyRatePerUnit !== 'number') {
    return null;
  }
  const hourlyItemPrice = hourlyRatePerUnit / FRACTIONAL_TO_BASIC_MONETARY_UNIT_FACTOR;
  const hourlyRate = hourlyRatePerUnit * multiplier;
  const hourlyPrice = hourlyRate / FRACTIONAL_TO_BASIC_MONETARY_UNIT_FACTOR;
  const monthlyPrice = millicentsToMonthlyPrice(hourlyRate);
  const currency = entity?.currency ?? 'usd';
  return { hourlyItem: hourlyItemPrice, hourlyTotal: hourlyPrice, monthlyTotal: monthlyPrice, currency };
}
